// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"5c914433","268":"392a1a60","321":"d4702def","453":"f99cae61","457":"8a0553c8"}[chunkId] + ".chunk.js";
};